import React from 'react'
import clsx from 'clsx'
import ArrowDropDownRoundedIcon from '@mui/icons-material/ArrowDropDownRounded'
import ArrowDropUpRoundedIcon from '@mui/icons-material/ArrowDropUpRounded'
import { MenuItem } from '@mui/material'
import { UserMenuItemGroupProps } from './_props'
import useStyles from './styles/UserMenuItemStyles'
import UserMenuItemLabel from './UserMenuItemLabel'

const UserMenuItemGroup = ({ label, icon, children, separator, isOpen=false }: UserMenuItemGroupProps) => {
    const classes = useStyles()

    const [isItemGroupOpen, setIsItemGroupOpen] = React.useState(isOpen)

    return (
        <div>
            {separator !== false && <div className={classes.UserMenuItemSeparator} />}
            <MenuItem
                key={`item-menu-group-${label}`}
                onClick={() => setIsItemGroupOpen(!isItemGroupOpen)}
                className={classes.userMenuGroup}
            >
                <div className={classes.userMenuGroupItemContainer}>
                    <UserMenuItemLabel label={label} icon={icon} />
                    {!isItemGroupOpen ? <ArrowDropDownRoundedIcon /> : <ArrowDropUpRoundedIcon />}
                </div>
                <div
                    className={clsx(
                        classes.UserMenuDialogListSubMenu,
                        isItemGroupOpen ? classes.UserMenuDialogListSubMenuOpen : ''
                    )}
                >
                    {children}
                </div>
            </MenuItem>
        </div>
    )
}

export default UserMenuItemGroup
